import { render, staticRenderFns } from "./commissio.vue?vue&type=template&id=6903ef28&scoped=true&"
import script from "./commissio.vue?vue&type=script&lang=js&"
export * from "./commissio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6903ef28",
  null
  
)

export default component.exports